export default __webpack_public_path__ + "static/media/loginbg22.43bd2031.jpg";